import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CehrLissageRequest, CehrSimulationRequest } from '../models/cehr-simulation-request';
import {
  CehrLissageResponse,
  CehrSimulationResponse,
} from '../models/cehr-simulation-response.model';

@Injectable({
  providedIn: 'root',
})
export class CehrSimulationService {
  private readonly http = inject(HttpClient);

  public postCehrSimulation(
    cehrSimulationRequest: Partial<CehrSimulationRequest>,
  ): Observable<CehrSimulationResponse> {
    return this.http.post<CehrSimulationResponse>(
      '/rgg/fis/v1/cehr/simulation',
      cehrSimulationRequest,
    );
  }

  public postCehrSimulationLissage(
    cehrSimulationLissageRequest: Partial<CehrLissageRequest>,
  ): Observable<CehrLissageResponse> {
    return this.http.post<CehrLissageResponse>(
      '/rgg/fis/v1/cehr/smoothing',
      cehrSimulationLissageRequest,
    );
  }
}
